export default [
    "8 8",
    '<circle cx="4" cy="4" r="4" fill="var(--ci-primary-color, currentColor)"/>']

